import React from 'react';
import { Box, withStyles } from '@material-ui/core';

export const ContainerBox = withStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
    width: '100%',
  },
}))((props) => <Box {...props} />);

export default ContainerBox;
